import React, { Component } from 'react';
import Modal from 'react-modal';
import Selector from '../shared/Selector';
import CurriculumModal from '../../containers/curriculum/CurriculumModalContainer';

export default class Curriculum extends Component {
  constructor(props) {
    super(props);
    this.state = {
      yearId: 0,
      specId: 0,
      modal: false,
    };
    this.searchForYear = this.searchForYear.bind(this);
    this.searchForSpec = this.searchForSpec.bind(this);
    this.renderCurriculum = this.renderCurriculum.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }
  componentWillMount() {
    this.props.didMount();
    window.scrollTo(0, 0);
  }

  searchForYear(yearId) {
    this.setState({ yearId });
  }

  searchForSpec(specId) {
    this.setState({ specId });
  }

  toggleModal(id) {
    this.setState({ modal: id });
  }

  renderCurriculum(plan, index) {
    return (
      <tr key={index} onClick={() => this.toggleModal(plan.idcurriculum)}>
        <td >{plan.Название}</td>
        <td >{plan['Воен.специальн.']}</td>
        <td >{plan.Поколение}</td>
        <td >{plan.ФГОС}</td>
        <td >{plan.КТ}</td>
        <td >{plan.Факультет}</td>
        <td >{plan['Колич.групп']}</td>
      </tr>);
  }

  render() {
    const { studyYear, specialty, curriculum } = this.props;
    const { yearId, specId, modal } = this.state;
    /* eslint-disable */
    return (
      <div className="17jpg upper">
        <div className="captions">Разработка учебных планов и программ</div>
        <div className="plans">
          <p>Специальность</p>
          <div className="inputs__input CURR-input">
            <Selector
              options={specialty}
              onChange={(specId) => this.searchForSpec(specId)}
            />
          </div>
          <p>Год набора</p>
          <div className="inputs__input CURR-input">
            <Selector
              options={studyYear}
              onChange={(yearId) => this.searchForYear(yearId)}
            />
          </div>
          {// eslint-disable-next-line
            <a
              className="Ms-writeMessage"
              onClick={() => this.props.getCurriculum(yearId, specId)}
            >Обновить</a>}
          <table >
            <thead>
            <tr>
              <th>Название</th>
              <th>Воен.специальн.</th>
              <th>Поколение</th>
              <th>ФГОС</th>
              <th>КТ</th>
              <th>Факультет</th>
              <th>Колич.групп</th>
            </tr>
            </thead>
            <tbody>
            {curriculum && curriculum.map(this.renderCurriculum)}
            </tbody>
          </table>
          <Modal
            isOpen={!!modal}
            onRequestClose={() => this.toggleModal(false)}
            contentLabel="Modal"
          >
            <CurriculumModal id={modal} onRequestClose={() => this.toggleModal(false)}/>
          </Modal>
        </div>
      </div>
    );
  }
}

